<template>
	<div
        :class="['box p-3', declaration.class]"
    >
        <div
            class="details "
        >

            <h2
                class="fw-semibold m-0"
            >
                {{ declaration.count | numberFormat}}
            </h2>

            <h5
                class="title fw-semibold"
            >
                {{ declaration.title }}
            </h5>
        </div>

        <div>

            <!-- <i :class="['text-white', declaration.icon]"></i> -->
        </div>

    </div>
</template>

<script>

    export default
    {

        props:{
            declaration: Object,
        },
        name:'CardComponent',
        data()
        {
            return {

            }
        },
        mounted()
        {

        },
        methods:
        {

        },
        computed:
        {

        },
        destroyed()
        {

        }
    }
</script>

<style  lang="scss">

.box {

  padding:10px;
  text-shadow: 0 1px 1px 1px #666;
  box-shadow: 4px 15px 15px -9px rgba(69, 65, 78, 0.5);
  height: 100%;
  border-radius: 5px;
  width: 100%;
  display: flex;
  justify-content: space-between;

    .details {
        font-weight: bold;
        text-align: start;
        color: #fff;
        .title{
            // width: 80%;
            overflow-wrap: break-word;
        }

    }
}



.box-1 {
    background-image: linear-gradient(135deg, #e934d5, #6c3e9a);
}

.box-2 {
  background-image: linear-gradient(135deg, #329db9 10%, #63fa61 100%);
}

.box-3 {
    background-image: linear-gradient(135deg, #ea902e 10%, #FD6585 100%);
}

.box-4 {
    background-image: linear-gradient(135deg, #EE9AE5 10%, #864dc0 100%);
}


</style>
